<script>
  import Chart from './chart.svelte';
  import BumpChart from './bumpChart.svelte';
  export let contents;
</script>

<style lang="scss">
  main {
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 5rem;
  }

  h3 {
    font-size: 1.8rem;
    margin: 1rem 0 0.25rem 0;
    padding: 1.5rem;
  }

  p {
    font-size: 1.6rem;
    font-weight: 300;
    padding: 1rem 1.5rem;
  }

  ul {
    font-size: 1.6rem;
    font-weight: 300;
    margin-left: 2em;
    padding: 1.5rem;
  }

  li {
    margin: 1rem 0;
  }

  .banner {
    width: 100%;
    margin: 2rem 0;

    &--image {
      width: 100%;
    }

    & .source {
      text-align: center;
    }
  }

  .outro {
    font-size: 1.8rem;
    font-weight: 400;
  }

  .note {
    font-size: 1rem;
  }

  .center {
    text-align: center;
  }
</style>

<main>
  {#each contents as { text, type, chart, figcap, list, src, alt, modifier, source }}
    {#if type === 'Heading'}
      <h3>{text}</h3>
    {:else if type === 'Chart'}
      <Chart {chart} {figcap} />
    {:else if type === 'Content'}
      <p class={modifier}>
        {@html text}
      </p>
    {:else if type === 'List'}
      <ul>
        {#each list as listitem}
          <li>
            {@html listitem}
          </li>
        {/each}
      </ul>
    {:else if type === 'Banner'}
      <div class="banner">
        <img {src} {alt} class="banner--image" />
        {#if source}
          <div class="source">ที่มา : {source}</div>
        {/if}
      </div>
    {/if}
  {/each}
</main>
